<template>
  <div>
    <p class="text-muted">{{ $t("TRAININGS.PATHS_DESCRIPTION") }}</p>
    <div v-if="loading" class="text-center py-4">
      <img src="/img/loading.gif" style="height: 80px; width: 80px" />
    </div>
    <template v-else>
      <el-select
        v-model="roleId"
        filterable
        class="mb-4 training-role-select"
        :placeholder="$t('TRAININGS.SELECT_ROLE')"
      >
        <el-option
          v-for="role in paths"
          :key="role.id"
          :value="role.id"
          :label="role.name"
        >
          <span>{{ role.name }}</span>
          <small class="text-muted ml-2">
            {{
              $tc("TRAININGS.ROLE_FILES", role.files.length, {
                count: role.files.length,
              })
            }}
            ·
            {{
              $tc("TRAININGS.ROLE_ACTIVE_USERS", role.users_count, {
                count: role.users_count,
              })
            }}
          </small>
        </el-option>
      </el-select>

      <div v-if="selectedRole" class="border rounded p-3">
        <h4 class="mb-0">{{ selectedRole.name }}</h4>
        <small class="d-block text-muted mb-3">
          {{
            $tc("TRAININGS.ROLE_ACTIVE_USERS", selectedRole.users_count, {
              count: selectedRole.users_count,
            })
          }}
        </small>
        <training-files-editor
          :files="selectedRole.files"
          :saving="saving"
          @save="save"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Option, Select } from "element-ui";
import TrainingFilesEditor from "@/components/Trainings/TrainingFilesEditor.vue";

export default {
  name: "training-role-paths",

  components: {
    TrainingFilesEditor,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      loading: true,
      saving: false,
      roleId: null,
    };
  },

  computed: {
    ...mapGetters({ paths: "trainings/paths" }),
    selectedRole() {
      return this.paths.find((role) => role.id === this.roleId) || null;
    },
  },

  async created() {
    try {
      await this.$store.dispatch("trainings/paths");
    } catch (error) {
      this.$notify({
        type: "danger",
        message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
      });
    }
    this.loading = false;
  },

  methods: {
    async save(fileIds) {
      this.saving = true;
      try {
        await this.$store.dispatch("trainings/updatePath", {
          roleId: this.roleId,
          fileIds,
        });
        this.$notify({ type: "success", message: this.$t("TRAININGS.SAVED") });
      } catch (error) {
        this.$showRequestError(error);
      }
      this.saving = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.training-role-select {
  width: 100%;
  max-width: 480px;
}
</style>
